import { Component, ChangeDetectionStrategy, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { map, Observable } from "rxjs";

@Component({
  standalone: false,
  selector: "formly-field-combobox",
  templateUrl: "./combobox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldCombobox extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {

  @ViewChild('combo') private combo;

  ngOnInit(): void {
  }

  override defaultOptions = {
    props: {
      allowCustom: false,
      valuePrimitive: true,
      valueNormalizer: (text: Observable<string>) =>
        text.pipe(
          map((content: string) => {
            return {
              value: null,
              label: content
            };
          })
        )
    },
  };

  public ngAfterViewInit() {
    this.combo.searchbar.input.nativeElement.setAttribute('maxlength', this.props.maxLength)
  }

}
